module.exports = __webpack_public_path__ + "img/noteScreen.aad618cb.png";